import { createSelector } from 'reselect'
import { OrganizationRoles } from 'src/enums'
import {
  CspUserListModel,
  CspUserListResponse,
} from 'src/models/cspUser.models'
import { UserListModel, UserListResponse } from 'src/models/user.models'
import { RootState } from 'src/redux/createRootReducer'

export const selectUserListResponsesFromState = (
  state: RootState,
): Record<string, UserListResponse> => state.data.users.listResponses

export const selectUserListModelsFromState = createSelector(
  [selectUserListResponsesFromState],
  (userListResponses) =>
    Object.values(userListResponses).reduce<
      Record<UserListResponse['id'], UserListModel>
    >(
      (acc, curr) => ({
        ...acc,
        [curr.id]: new UserListModel(curr),
      }),
      {},
    ),
)

export const selectUserEmailMap = createSelector(
  [selectUserListModelsFromState],
  (users) =>
    Object.values(users).reduce(
      (acc: Record<string, UserListModel>, curr) => ({
        ...acc,
        [curr.email]: curr,
      }),
      {},
    ),
)

export const selectGuestUserEmailMap = createSelector(
  [selectUserListModelsFromState],
  (users) =>
    Object.values(users)
      .filter((user) => user?.organizationRole === OrganizationRoles.guest)
      .map((user) => user.email),
)

export const selectCspUserListResponsesFromState = (
  state: RootState,
): Record<string, CspUserListResponse> => state.data.users.cspResponses

export const selectCspUserListModelsFromState = createSelector(
  [selectCspUserListResponsesFromState],
  (cspUserListResponses) =>
    Object.entries(cspUserListResponses).reduce(
      (acc, curr) => ({
        ...acc,
        [curr[0]]: new CspUserListModel(curr[1]),
      }),
      {} as Record<string, CspUserListModel>,
    ),
)
